import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { ChatStore } from '../store';
import { environment } from 'src/environments/environment';
import { Chat } from 'src/app/common/models/ai-reports/shared/chat';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Thin HTTP client for chat-related endpoints, e.g. chatThreadsResource, deleteThread
 *
 */
@Injectable()
export class ChatClientService {
  private readonly http = inject(HttpClient);
  private readonly chatStore = inject(ChatStore);

  private readonly threadsEndpoint = `${environment.apiBaseUrl}${environment.endpoint.ai.listThreads}`;

  /**
   * Resource for listing all chat threads.
   *
   * @param threadId A signal getter used only to trigger reloads when the active thread changes.
   */
  chatThreadsResource = rxResource<Chat[], void>({
    params: () => this.chatStore.thread_id() ?? '',
    stream: () =>
      this.listThreads()
        .pipe
        /*
        catchError((error) => {
          console.error(error);
          return of(error);
        })
*/
        (),
    defaultValue: [],
  });

  /**
   * Lists all chat threads.
   *
   * Edge cases: network errors propagate to the caller (e.g. rxResource error()).
   */
  private listThreads(): Observable<Chat[]> {
    return this.http.get<Chat[]>(this.threadsEndpoint).pipe(
      map(threads =>
        [...threads].sort(
          (a, b) => new Date(b.modified_at).getTime() - new Date(a.modified_at).getTime()
        )
      )
    );
  }

  /**
   * Deletes a single thread by id.
   *
   * Edge cases: unknown id -> server decides (typically 404).
   */
  deleteThread(threadId: string) {
    return this.http.delete(
      `${this.threadsEndpoint}/${encodeURIComponent(threadId)}`
    );
  }
}
